import { LoadingWrapper, LoadingSpin } from "./style";
import RotateLeftSharpIcon from "@mui/icons-material/RotateLeftSharp";
import { orange } from "@mui/material/colors";

export default function Loading() {
  return (
    <LoadingWrapper>
      <LoadingSpin>
        <RotateLeftSharpIcon sx={{ fontSize: 50, color: orange[50] }} />
      </LoadingSpin>
    </LoadingWrapper>
  );
}
